import React, { useState } from "react"
import {
  Box,
  Grid,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tooltip,
} from "@mui/material"

import * as Style from "./style"
import { IoStarOutline } from "react-icons/io5"
import { TbArrowsSort } from "react-icons/tb"
import { IoStar } from "react-icons/io5"
import { FaPencilAlt } from "react-icons/fa"
import { Link } from "react-router-dom"
import {
  useProviderReviewsQuery,
  useSeekerReceivedReviewasQuery,
} from "../../features/Auth/authApi"
import dummy from "../../images/dummy-image.jpg"
import nodata from "../../images/no-results.svg"
import CenteredSpinner from "../common/CenteredSpinner"
import {
  FormatChangeTime,
  FormatDate,
  FormatTime,
} from "../common/utctolocalDate"
import { MdOutlineLocationOn } from "react-icons/md"

interface Array { }
const SeekerProvider = () => {
  const [selectedPage, setSelectedPage] = useState(1)

  const [showMore, setShowMore] = useState<Array>([])

  const {
    data: seekerReview,
    isLoading: isloadingSeekers,
    error: seekerReviewError,
  } = useProviderReviewsQuery({})

  const {
    data: receviedReviews,
    isLoading,
    isFetching,
  } = useSeekerReceivedReviewasQuery({
    pageNo: selectedPage,
  })

  const handlePageChange = (event: any, value: any) => {
    setSelectedPage(value)
  }

  const RatingStars = ({ rating }: props) => {
    const starsArray = Array.from({ length: rating }, (_, index) => index + 1)
    let emptyArray: JSX.Element[] = []

    if (rating < 5) {
      for (let i = 0; i < 5 - rating; i++) {
        emptyArray.push(
          <IoStarOutline
            key={rating + i}
            style={{ color: "rgb(175 174 174)" }}
          />,
        )
      }
    }
    return (
      <Box className="d-flex review-stars gap-1">
        {starsArray.map((star) => (
          <IoStar key={star} className="active" />
        ))}
        {emptyArray}
      </Box>
    )
  }

  const toggleShowMore = (index: any) => {
    setShowMore((prevShowMore: any) => {
      const newShowMore = [...prevShowMore]
      newShowMore[index] = !newShowMore[index]
      return newShowMore
    })
  }

  return (
    <>
      {isLoading || isFetching ? (
        <CenteredSpinner />
      ) : (
        <Style.Overview>
          <Grid container>
            <Grid item xs={12}>
              {seekerReview?.alreadyReviewed !== true && (
                <>
                  <Box className="d-flex justify-content-between mt-5">
                    <Typography variant="h2" className="pink-text">
                      Reviews
                    </Typography>
                  </Box>

                  <TableContainer
                    component={Paper}
                    className="dashboard-table-wrapper custom-scrollbar mb-5"
                  >
                    <Table
                      sx={{
                        minWidth: 900,
                        border: "none",
                        backgroundColor: "transparent",
                      }}
                      className="dashboard-table"
                      aria-label="simple table"
                    >
                      <TableHead>
                        <TableCell component="th"></TableCell>
                        <TableCell component="th" className="service-head">
                          Service Customer <TbArrowsSort />
                        </TableCell>
                        <TableCell component="th" align="center">
                          Email
                        </TableCell>
                        <TableCell component="th" align="center">
                          Service Required
                        </TableCell>
                        <TableCell component="th" align="center">
                          Location <MdOutlineLocationOn />
                        </TableCell>

                        <TableCell component="th" align="center">
                          Action
                        </TableCell>
                      </TableHead>
                      <TableBody>
                        {seekerReview?.data?.length > 0
                          ? seekerReview?.data?.map((item: any) => (
                            <TableRow
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell>
                                <div
                                  style={{
                                    width: "74px",
                                    height: "74px",
                                    objectFit: "cover",
                                  }}
                                >
                                  <img
                                    src={
                                      item?.seekerData?.profilePic || dummy
                                    }
                                    style={{
                                      width: "74px",
                                      height: "74px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>
                              </TableCell>
                              <TableCell
                                component="td"
                                align="center"
                                scope="row"
                              >
                                <span className="text flex-column gap-2">
                                  {item?.seekerData?.name}

                                  <span className="minh-1 gold ">
                                    <RatingStars
                                      rating={
                                        item?.seekerData?.rating
                                          ?.$numberDecimal
                                      }
                                    />
                                  </span>
                                </span>
                              </TableCell>
                              <TableCell align="center">
                                <Tooltip
                                  title={item?.seekerData?.email || ""}
                                >
                                  <span>
                                    {item?.seekerData?.email?.length > 20
                                      ? `${item?.seekerData?.email.slice(
                                        0,
                                        20,
                                      )}...`
                                      : item?.seekerData?.email}
                                  </span>
                                </Tooltip>
                              </TableCell>

                              <TableCell align="center">
                                <Tooltip title={item?.service?.name || ""}>
                                  <span>
                                    {item?.service?.name?.length > 20
                                      ? `${item?.service?.name.slice(
                                        0,
                                        20,
                                      )}...`
                                      : item?.service?.name}
                                  </span>
                                </Tooltip>
                              </TableCell>

                              <TableCell align="center">
                                <Tooltip title={item?.location || ""}>
                                  <span className="location">
                                    {item?.location?.length > 20
                                      ? `${item?.location.slice(0, 20)}...`
                                      : item?.location}
                                  </span>
                                </Tooltip>
                              </TableCell>

                              <TableCell align="center">
                                <span>
                                  <Link
                                    to={`/dashboard/write-review/${item?.seekerData?._id}?postId=${item?._id}`}
                                    className="view-profile d-flex align-items-center gap-1 "
                                  >
                                    Write Review
                                    <FaPencilAlt />
                                  </Link>
                                </span>
                              </TableCell>
                            </TableRow>
                          ))
                          : ""}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}

              <Box className="d-flex justify-content-between mt-5">
                <Typography variant="h2" className="pink-text">
                  Reviews From Customers
                </Typography>
              </Box>
              <TableContainer
                component={Paper}
                className="dashboard-table-wrapper custom-scrollbar mb-3"
              >
                <Table
                  sx={{
                    minWidth: 900,
                    border: "none",
                    backgroundColor: "transparent",
                  }}
                  className="dashboard-table"
                  aria-label="simple table"
                >
                  {receviedReviews?.data?.length > 0 && (
                    <TableHead>
                      <TableRow>
                      <TableCell component="th"></TableCell>
                      <TableCell component="th" className="service-head">
                        Service Customer
                      </TableCell>
                      <TableCell component="th" align="center">
                        Review
                      </TableCell>
                      <TableCell component="th" align="center">
                        Date & Time
                      </TableCell>
                      <TableCell component="th" align="center">
                        Rating
                      </TableCell>
                      </TableRow>
                    </TableHead>
                  )}
                  <TableBody>
                    {receviedReviews?.data?.length > 0 ? (
                      receviedReviews?.data?.map((item: any, index: number) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                          <TableCell>
                            <div
                              style={{
                                width: "74px",
                                height: "74px",
                                objectFit: "cover",
                              }}
                            >
                              <img
                                src={item?.seekerData?.profilePic || dummy}
                                style={{
                                  width: "74px",
                                  height: "74px",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                          </TableCell>
                          <TableCell component="td" scope="row">
                            <span className=" d-flex justify-content-start">
                              {item?.seekerData?.name}

                              <span className="minh-1 gold ">
                                <RatingStars
                                  rating={
                                    item?.seekerData?.rating?.$numberDecimal
                                  }
                                />
                              </span>
                            </span>
                          </TableCell>

                          <TableCell align="center">
                            <Tooltip title={item?.message || ""} arrow placement="bottom"
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    bgcolor: "rgba(50, 50, 50, 0.9)", // semi-transparent dark gray
                                    maxWidth: 700,
                                    whiteSpace: "pre-line",
                                  },
                                },
                              }}
                            >
                              <span>
                                {(item?.message || "").length > 20
                                  ? item?.message.slice(0, 20) + "..."
                                  : item?.message}
                              </span>
                            </Tooltip>
                          </TableCell>
                          <TableCell align="center">
                            <span className="datetime">
                              <span className="d-flex flex-column">
                                <span className="weekday">
                                  {" "}
                                  <FormatDate dateString={item?.createdAt} />
                                </span>

                                <span className="">
                                  <FormatChangeTime
                                    dateString={item?.createdAt}
                                  />
                                </span>
                                <span className="">
                                  <FormatTime dateString={item?.createdAt} />
                                </span>
                              </span>
                            </span>{" "}
                          </TableCell>
                          <TableCell align="center">
                            <span style={{ color: "#FFB800" }}>
                              <RatingStars rating={item?.rating} />
                            </span>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <>
                        <TableRow
                          sx={{
                            height: "40vh",
                            backgroundColor: "white",
                          }}
                        >
                          <TableCell
                            align="center"
                            colSpan={7}
                            sx={{
                              width: "100%",
                              pointerEvents: "none",
                              border: "none",
                            }}
                          >
                            <img
                              src={nodata}
                              style={{
                                width: "100%",
                                maxWidth: "180px",
                              }}
                            />
                            <span
                              className="no-data-text"
                              style={{
                                fontSize: "20PX",
                                fontWeight: "600",
                                color: "#000",
                              }}
                            >
                              No Data Found
                            </span>
                          </TableCell>
                        </TableRow>
                      </>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              {receviedReviews?.data?.length > 1 && (
                <Box className="d-md-flex justify-content-between">
                  <Typography variant="body1" className="w-auto white-space">
                    {" "}
                    Showing {receviedReviews?.totalDocument?.showingData} -{" "}
                    {receviedReviews?.totalDocument?.showingEnd} list
                  </Typography>
                  <Grid container justifyContent="flex-end">
                    <Grid item md={3}>
                      <Box display="flex" className="flex-column">
                        <Stack spacing={2} className="mb-3">
                          <Pagination
                            count={receviedReviews?.totalDocument?.totalPages}
                            color="secondary"
                            className="custom-pagination"
                            page={receviedReviews?.totalDocument?.pageNo}
                            onChange={handlePageChange}
                            sx={{
                              "& .MuiPaginationItem-page.Mui-selected": {
                                backgroundColor: "#F475A4",
                                boxSizing: "border-box",
                              },
                              "& .css-wjh20t-MuiPagination-ul": {
                                flexWrap: "nowrap",
                                justifyContent: "end",
                              },
                            }}
                          />
                        </Stack>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </Grid>
          </Grid>
        </Style.Overview>
      )}
    </>
  )
}
interface props {
  rating: number
}
export default SeekerProvider
